import { Type } from '@sinclair/typebox';
export var PaymentFileStatus;
(function (PaymentFileStatus) {
    PaymentFileStatus["INITIALIZED"] = "INITIALIZED";
    PaymentFileStatus["CREATED"] = "CREATED";
    PaymentFileStatus["FAILED"] = "FAILED";
    PaymentFileStatus["SUBMITTED"] = "SUBMITTED";
})(PaymentFileStatus || (PaymentFileStatus = {}));
export const nordeaInformationSchema = Type.Object({
    customerId: Type.String(),
    ccmId: Type.String(),
});
export const PaymentFileInformationRequestSchema = Type.Object({
    invoicesIds: Type.Array(Type.String()),
    requestPaymentDate: Type.String({ format: 'date' }),
});
export const PaymentFileSubmitParamSchema = Type.Object({
    id: Type.String(),
});
export const PaymentFileDatabaseSchema = Type.Object({
    id: Type.Integer(),
    status: Type.String(),
    fileBlob: Type.String(),
    failureReason: Type.String(),
    supplierInvoiceIds: Type.Array(Type.String()),
});
